module.exports = __webpack_public_path__ + "static/media/front.69eaff40.jpg";